module.exports = __webpack_public_path__ + "static/media/tz.5cff96bc.svg";